import React from "react";
import { Card, CardBody, CardTitle, Button } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (<><Helmet> <title>404 Page Not Found - IndexBooster</title></Helmet>
    <div className="container py-5 text-center">
      <Card>
        <CardBody>
          <CardTitle as="h2">404 - Page Not Found</CardTitle>
                    <Button variant="primary" onClick={() => (window.location.href = "/")}>Back to Homepage</Button>
        </CardBody>
      </Card>
    </div>
 </> );
}
